import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { http } from "@/lib/api";
import { ArrowLeft, Clock } from "@phosphor-icons/react";
import { Badge } from "@/components/ui/badge";
import PageSEO from "@/components/PageSEO";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { http.get(`/blog/${slug}`).then(r => setPost(r.data)).catch(() => {}); }, [slug]);
  if (!post) return <div className="container-wide py-24 text-slate-500">Loading…</div>;

  const desc = (post.excerpt || (post.content || "").replace(/<[^>]*>/g, "").slice(0, 160)).trim();
  const ld = {
    "@context": "https://schema.org",
    "@type": "Article",
    "headline": post.title,
    "image": post.image_url ? [post.image_url] : [],
    "datePublished": post.published_at,
    "author": { "@type": "Organization", "name": post.author || "Mayoto" },
    "publisher": { "@type": "Organization", "name": "Mayoto", "logo": { "@type": "ImageObject", "url": "https://mayotofocus.com/favicon.svg" } },
    "articleSection": post.category,
    "mainEntityOfPage": `https://mayotofocus.com/insights/${slug}`
  };

  return (
    <div>
      <PageSEO
        title={post.title}
        description={desc}
        canonicalPath={`/insights/${slug}`}
        image={post.image_url}
        ogType="article"
        jsonLd={ld}
      />
      <section className="mayo-grain">
        <div className="container-wide py-16 max-w-3xl">
          <Link to="/insights" className="inline-flex items-center gap-1 text-sm text-slate-600 hover:text-[#00b4d8] mb-6"><ArrowLeft size={16} /> Back to Insights</Link>
          <div className="flex items-center gap-2 mb-3">
            <Badge className="bg-[#00b4d8]/10 text-[#00b4d8] hover:bg-[#00b4d8]/10">{post.category}</Badge>
            <span className="text-xs text-slate-500 inline-flex items-center gap-1"><Clock size={12} />{post.reading_time}</span>
          </div>
          <h1 className="font-display font-black text-3xl lg:text-5xl text-[#0a1128] leading-[1.05]" data-testid="blog-title">{post.title}</h1>
          <p className="mt-4 text-sm text-slate-500">By {post.author} • {new Date(post.published_at).toLocaleDateString()}</p>
        </div>
      </section>
      {post.image_url && (
        <div className="container-wide max-w-4xl">
          <img src={post.image_url} alt={post.title} className="rounded-3xl w-full aspect-video object-cover" />
        </div>
      )}
      <section className="py-12">
        <div className="container-wide max-w-3xl">
          <div className="prose prose-slate max-w-none">
            {post.content.split("\n\n").map((para, i) => (
              <p key={i} className="text-slate-700 leading-relaxed text-lg mb-6">{para}</p>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
